import { CampaignAdGroupInventorySource } from '../types/Campaign';
import {
    InventorySourceTypeGroup as DspInventorySourceTypeGroup,
    InventorySource as DspInventorySource,
} from '../types/Inventory';

const DspInventorySourceUtils = {
    toDspInventorySourceIds: (targets: CampaignAdGroupInventorySource[]) => {
        return targets?.map((target: CampaignAdGroupInventorySource) => target.dspInventoryId) || [];
    },
    toDspInventorySourceTypeGroups: (targets: DspInventorySource[]): DspInventorySourceTypeGroup[] => {
        const groups: DspInventorySourceTypeGroup[] = [];
        const group: { [key: string]: DspInventorySourceTypeGroup } = {};

        if (targets) {
            targets.forEach((target: DspInventorySource) => {
                let code: string = target.inventorySourceType;
                if (code) {
                    if (!group[code]) {
                        group[code] = new DspInventorySourceTypeGroup();
                        group[code].inventorySourceType = code;
                        groups.push(group[code]);
                    }
                    group[code].inventorySources.push(target);
                }
            });
        }

        return groups;
    },
};

export default DspInventorySourceUtils;
